import { connect } from 'react-redux'
import { switchToggle } from '../../../store/actions/toggles'
import { compose, branch, withProps, renderNothing, lifecycle } from 'recompose'
import {
  selectQueueIndex,
  increaseCols,
  decreaseCols,
  clearQueue
} from '../../../store/actions/queue'
import Shortcuts from '../../../containers/Shortcuts'
import {
  queueSelector,
  queueOpenSelector,
  queueIndexSelector,
  placementWidthSelector,
  uploadsSelector
} from '../../../store/selectors/selectors'
import { withTranslation } from 'react-i18next'

import Queue from './Queue'

export const clearFailedUploads = lifecycle({
  componentDidMount() {
    console.log(this.props.blocks)
    this.props.blocks.forEach(({ value }) => {
      // if uploading but not in our local records, must be a past failed upload
      if (value.uploading && !(value.id in this.props.uploads))
        console.log(value)
    })
  }
})

export default compose(
  connect(
    state => {
      return {
        blocks: queueSelector(state),
        panelOpen: queueOpenSelector(state),
        selectedIndex: queueIndexSelector(state),
        columns: placementWidthSelector(state),
        uploads: uploadsSelector(state)
      }
    },
    dispatch => ({
      toggleQueue: () => dispatch(switchToggle('queue')),
      increaseCols: () => dispatch(increaseCols()),
      decreaseCols: () => dispatch(decreaseCols()),
      clearQueue: () => dispatch(clearQueue()),
      selectQueueIndex: index => dispatch(selectQueueIndex(index))
    }),
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      nextQueueItem: () => {
        return dispatchProps.selectQueueIndex(
          Math.min(
            stateProps.selectedIndex + 1,
            Object.keys(stateProps.blocks).length - 1
          )
        )
      },
      prevQueueItem: () => {
        return dispatchProps.selectQueueIndex(
          Math.max(stateProps.selectedIndex - 1, 0)
        )
      }
    })
  ),
  // clearFailedUploads,
  withProps(props => ({
    blocks: Object.values(props.blocks || {})
      .reverse()
      .map(({ value }) => value)
      // if block is uploading but not in uplaods we can't display (probably failed upload)
      .filter(block => !block.uploading || block.id in props.uploads)
  })),
  branch(props => !props.panelOpen, renderNothing),
  Shortcuts(
    'QUEUE',
    props => (action, event) => {
      switch (action) {
        case 'NEXT':
          props.nextQueueItem()
          break
        case 'PREVIOUS':
          props.prevQueueItem()
          break
        case 'INCREASE_COLS':
          props.increaseCols()
          break
        case 'DECREASE_COLS':
          props.decreaseCols()
          break
        case 'CLOSE_QUEUE':
          props.toggleQueue()
          break
        default:
          break
      }
    }
    // { preventDefault: true }
  ),
  withTranslation()
)(Queue)
